import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { appendSourceParameter, sendEvent } from "../../gtm/functions";
import { IGTMEventType } from "../../gtm/IGTMEventType";
import { getPassData } from "../(general-header)/botb-pass/subscription-service";

const PostalExpand = ({
  isUpsellModal,
  updateMilestones,
}: {
  isUpsellModal?: boolean;
  updateMilestones?: Dispatch<SetStateAction<string>>;
}) => {
  //postal expand collapse start
  const [isTextOpen, setTextOpen] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [data, setData] = useState<BotBPassProps>();

  useEffect(() => {
    sendEvent(
      isUpsellModal ? IGTMEventType.SubscriptionUpsellPopupView : IGTMEventType.SubscriptionPageView,
      appendSourceParameter(isUpsellModal)
    );
    (async () => {
      try {
        const response = await getPassData();
        const data = (await response.json()) as BotBPassProps;
        setData(data);
        updateMilestones(data.Milestones);
      } catch (err) {
        console.error(`Error while retreiving subscriptions - ${JSON.stringify(err)}`);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  const getPostalEntryTextContent = () =>
    isLoading ? (
      <Skeleton
        count={1}
        inline
        highlightColor="#fff"
        containerClassName="flex flex-col w-full px-12 pb-5 h-[500px]"
        className="h-full"
      />
    ) : (
      <div className={""}>
        <div className={"text-dark-1 text-lg leading-6 font-medium font-jost lg:text-xl lg:leading-6.5 mb-3 lg:mb-2"}>
          Free postal entry
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: data?.PostalEntryText,
          }}
          className={[
            `text-secondary text-left text-[13px] lg:text-sm font-normal leading-5 font-roboto ${!isTextOpen && "line-clamp-[8] lg:line-clamp-4"}`,

            "[&>h2]:normal-case",
            "[&>h2]:mb-3",
            "[&>h2]:font-medium",
            "[&>h2]:text-[13px]",
            "[&>h2]:leading-5",
            "[&>h2]:text-left",
            "[&>h2]:text-secondary",
            "[&>h2]:lg:text-base",
            "[&>h2]:lg:mb-2",

            "[&>p]:mb-3",
            "[&>p]:lg:mb-2",
            "[&>p]:font-roboto",

            "[&>ul]:mb-3",
            "[&>ul]:lg:mb-2",
            "[&>ul>li]:text-secondary",
            "[&>ul>li]:text-[13px]",
            "[&>ul>li]:lg:text-sm",
            "[&>ul>li]:leading-5",
            "[&>ul>li]:tracking-normal",
          ].join(" ")}
        />
      </div>
    );
  //postal expand collapse end

  return (
    <>
      <div className={"px-4 mb-5"}>
        <div id={"FreePostal"} className={"p-4 border border-black/12 rounded-2xl bg-white mb-6 lg:mb-5 lg:relative"}>
          <div
            className={`max-lg:mb-4 transition-[max-height] duration-400 ease-in-out overflow-hidden lg:mx-auto ${
              isTextOpen ? "max-h-[9999px]" : "max-h-[290px] lg:max-h-[86px]"
            }`}>
            {getPostalEntryTextContent()}
          </div>
          <div
            className={" mt-3 cursor-pointer flex items-center gap-2 lg:absolute lg:top-4 lg:right-4 lg:z-20"}
            onClick={() => {
              setTextOpen(prevState => !prevState);
            }}>
            <div className={"text-secondary font-jost text-xs font-medium leading-4 underline"}>
              {isTextOpen ? "Hide details" : "Show details"}
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              className={`${isTextOpen ? "rotate-180" : "rotate-0"}`}>
              <path
                d="M4 6L8 10L12 6"
                stroke="#4C4C52"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>
    </>
  );
};

export default PostalExpand;
